var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuickbooks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 38,
    viewBox: "0 0 37 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 37.535C28.7173 37.535 37 29.2366 37 18.9999C37 8.76329 28.7173 0.464844 18.5 0.464844C8.28273 0.464844 0 8.76329 0 18.9999C0 29.2366 8.28273 37.535 18.5 37.535Z",
    fill: "#27AB83"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.13721 18.9994C5.13721 22.9803 8.35826 26.2075 12.3317 26.2075H13.3594V23.5302H12.3317C9.83785 23.5302 7.80943 21.4979 7.80943 18.9994C7.80943 16.5013 9.83785 14.4686 12.3317 14.4686H14.8012V28.4729C14.8012 29.9516 15.9975 31.1502 17.4734 31.1502V11.7913H12.3317C8.35826 11.7913 5.13721 15.0189 5.13721 18.9994ZM24.6691 11.7925H23.6413V14.4698H24.6691C27.1621 14.4698 29.1913 16.5025 29.1913 19.0006C29.1913 21.4988 27.1621 23.5314 24.6691 23.5314H22.1983V9.52715C22.1983 8.04846 21.002 6.84985 19.5261 6.84985V26.2087H24.6691C28.6421 26.2087 31.8635 22.9816 31.8635 19.0006C31.8635 15.0197 28.6421 11.7925 24.6691 11.7925Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickbooks);
export default __webpack_public_path__ + "static/media/quickbooks.72f1ad9f87695342f68d6d5eead805bf.svg";
export { ForwardRef as ReactComponent };